import React from "react";
import { Link } from "react-router-dom";
import dashboardRoutes from "../../routes/menuRoutes.jsx";
import havi_logo_collapsed from "../../assets/img/phase3/havi_logo_collapsed.svg";
import havi_logo_expanded from "../../assets/img/phase3/havi_logo_expanded.svg";
import arrow_left from "../../assets/img/phase3/arrow_left.svg";
import arrow_right from "../../assets/img/phase3/arrow_right.svg";
import feedback from "../../assets/img/phase3/feedback.svg";
import mailTo from "../../assets/img/phase3/email.svg";
import { useSelector } from "react-redux";

const Sidebar = ({
  location,
  onSelectRoute,
  isSidebarExpanded,
  setSidebarExpanded,
}) => {
  const authInfo = useSelector((state) => state.user.authInfo);

  return (
    <div
      id="sidebar"
      className={`sidebar ${isSidebarExpanded ? "expanded" : ""}`}
    >
      <Link to="/">
        {/* {isSidebarExpanded ? (
          <img
            className="logo-img"
            src={havi_logo_expanded}
            alt="havi logo only"
          />
        ) : ( */}
        <img
          className="logo-img"
          src={havi_logo_collapsed}
          alt="havi logo only"
        />
        {/* )} */}
      </Link>
      <div className="sidebar-wrapper">
        {dashboardRoutes.map(
          ({ hide, path, name, sidebarName, image, moduleKey }, key) => {
            if (
              !hide &&
              moduleKey &&
              authInfo.moduleAuthKeys.indexOf(moduleKey) > -1
            ) {
              return (
                <div
                  className={`${
                    location.pathname === path ? "active active-pro" : ""
                  } nav-row`}
                  key={key}
                  onClick={() => onSelectRoute(name)}
                >
                  <Link to={path}>
                    <div>
                      <img className="sidebar-icon" src={image} alt="img" />
                    </div>
                    <div style={{ fontSize: "9px", textAlign: "center" }}>
                      {sidebarName}
                    </div>
                  </Link>
                </div>
              );
            }

            return null;
          }
        )}
      </div>
      <div className="sidebar-toggle">
        <div>
          <a href="mailto: IR.Support@havi.com" >
            <img className="sidebar-icon" src={mailTo} alt="mailTo img" />
          </a>
          <div style={{ fontSize: "9px", marginBottom: '1rem' }}>Contact Support</div>
        </div>
        <div>
          <img className="sidebar-icon" src={feedback} alt="feedback img" />
        </div>
        <div style={{ fontSize: "9px" }}>Feedback</div>
      </div>
    </div>
  );
};

export default Sidebar;
